export default {
  abstract: [
    'virtual'
  ],
  access: [],
  alias: [],
  augments: [
    'extends'
  ],
  author: [],
  borrows: [],
  callback: [],
  class: [
    'constructor'
  ],
  classdesc: [],
  constant: [
    'const'
  ],
  constructs: [],
  copyright: [],
  default: [
    'defaultvalue'
  ],
  deprecated: [],
  description: [
    'desc'
  ],
  enum: [],
  event: [],
  example: [],
  exports: [],
  external: [
    'host'
  ],
  file: [
    'fileoverview',
    'overview'
  ],
  fires: [
    'emits'
  ],
  function: [
    'func',
    'method'
  ],
  global: [],
  ignore: [],
  implements: [],
  inheritdoc: [],
  inner: [],
  instance: [],
  interface: [],
  kind: [],
  lends: [],
  license: [],
  listens: [],
  member: [
    'var'
  ],
  memberof: [],
  mixes: [],
  mixin: [],
  module: [],
  name: [],
  namespace: [],
  override: [],
  param: [
    'arg',
    'argument'
  ],
  private: [],
  property: [
    'prop'
  ],
  protected: [],
  public: [],
  readonly: [],
  requires: [],
  returns: [
    'return'
  ],
  see: [],
  since: [],
  static: [],
  summary: [],
  this: [],
  throws: [
    'exception'
  ],
  todo: [],
  tutorial: [],
  type: [],
  typedef: [],
  variation: [],
  version: []
};
